import { jsx as c } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import s from "@mui/material/CardActionArea";
import d from "styled-components";
import { hexToRgba as A } from "../../../theme/utils/styleUtils.js";
const n = {
  root: "cardActionAreaRoot",
  focusHighlight: "cardActionAreaFocusHighlight",
  focusVisible: "cardActionAreaFocusVisible"
}, p = d(s).withConfig({
  displayName: "StyledCardActionArea"
})([
  "&&.cardActionAreaRoot{font-size:",
  ";",
  ";}&&.cardActionAreaRoot .cardActionAreaFocusHighlight{opacity:0;}&&.cardActionAreaRoot.Mui-focusVisible{box-shadow:0px 0px 4px 0px ",
  ";}"
], ({ theme: o }) => o.typography.body200.fontSize, ({ $disablePadding: o }) => o ? "padding: 0px" : "", ({ theme: o }) => A(o.primaryFocus, o.isLightTheme ? 0.5 : 1)), l = /* @__PURE__ */ e(({ children: o, disablePadding: i = !1, classes: a, ...r }, t) => /* @__PURE__ */ c(p, {
  ...r,
  ref: t,
  classes: {
    ...n,
    ...a
  },
  $disablePadding: i,
  children: o
}));
l.displayName = "CardActionArea";
export {
  l as default
};
